var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', {
    staticClass: "toolbar-container"
  }, [_vm.activityDataVisible || _vm.usernameVisible && _vm.username ? _c('article', [_c('article', {
    attrs: {
      "aria-label": _vm.userAndProgressHeading,
      "id": "user-and-progress-heading",
      "role": "region"
    }
  }, [_vm.usernameVisible && _vm.username ? _c('p', {
    staticClass: "username resizableText"
  }, [_vm._v(_vm._s(_vm.username))]) : _vm._e(), _vm.activityDataVisible ? _c('article', {
    staticClass: "activity-data"
  }, [_c('p', {
    staticClass: "resizableText"
  }, [_vm._v("Week " + _vm._s(_vm.nextWeek))]), _c('p', {
    staticClass: "resizableText"
  }, [_vm._v("#" + _vm._s(_vm.nextASN))])]) : _vm._e()])]) : _vm._e(), _vm.kwtMode !== 'previewLite' ? _c('ul', {
    staticClass: "kwt-toolbar"
  }, [_c('li', {
    class: ['toolbar-row', {
      show: _vm.fullScreenVisible
    }]
  }, [_c('button', {
    staticClass: "pure-button",
    attrs: {
      "aria-label": "Fullscreen",
      "tabindex": "2"
    },
    on: {
      "click": _vm.toggleFullscreen
    }
  }, [_c('fullscreen-icon', {
    attrs: {
      "is-fullscreen": _vm.isFullscreen
    }
  })], 1)]), _c('li', {
    class: ['toolbar-row', {
      show: _vm.restartVisible
    }]
  }, [_c('button', {
    staticClass: "pure-button",
    attrs: {
      "aria-label": "Restart",
      "tabindex": "3"
    },
    on: {
      "click": function ($event) {
        return _vm.restartActivity(true);
      }
    }
  }, [_c('restart-icon')], 1)]), _vm.kwtMode !== 'preview' ? [_c('li', {
    class: ['toolbar-row', {
      show: _vm.logoutVisible
    }]
  }, [_c('a', {
    staticClass: "pure-button",
    attrs: {
      "aria-label": "Log Out",
      "tabindex": "4"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('stop-icon')], 1)]), _c('li', {
    class: ['toolbar-row', {
      show: _vm.videoVisible
    }]
  }, [_c('button', {
    staticClass: "pure-button",
    attrs: {
      "aria-label": "Video Instructions",
      "tabindex": "5"
    },
    on: {
      "click": _vm.showVideo
    }
  }, [_c('video-icon')], 1)]), _c('li', {
    class: ['toolbar-row', {
      show: _vm.userProgressVisible
    }]
  }, [_c('button', {
    staticClass: "pure-button",
    attrs: {
      "aria-label": "Progress",
      "tabindex": "6"
    },
    on: {
      "click": _vm.showProgress
    }
  }, [_c('progress-icon')], 1)]), _c('li', {
    class: ['toolbar-row', 'volume-toolbar-row', {
      show: _vm.restartVisible || _vm.logoutVisible || _vm.fullScreenVisible
    }]
  }, [_c('button', {
    staticClass: "pure-button",
    attrs: {
      "aria-label": ("Volume Control - " + (_vm.soundMuted ? 'Muted' : ("Volume level - " + (_vm.volume) + "%"))),
      "tabindex": "7"
    },
    on: {
      "click": _vm.setShowVolumeControls
    }
  }, [!_vm.soundMuted ? _c('volume-icon', {
    attrs: {
      "height": "52px",
      "width": "52px"
    }
  }) : _vm._e(), _vm.soundMuted ? _c('muted-icon', {
    attrs: {
      "height": "52px",
      "width": "52px"
    }
  }) : _vm._e()], 1), _c('div', {
    class: ['toolbar-row', {
      show: _vm.showVolumeControls
    }],
    attrs: {
      "id": "volume-slider",
      "tabindex": "-1",
      "role": "button"
    }
  }, [_c('div', {
    attrs: {
      "id": "volume-slider-controls"
    }
  }, [_c('button', {
    staticClass: "pure-button volume-down-button",
    attrs: {
      "aria-label": "Mute or unmute volume"
    },
    on: {
      "click": function () {
        return _vm.updateVolume(_vm.volume - 20);
      }
    }
  }, [_c('volume-down-icon', {
    style: {
      display: !_vm.soundMuted ? 'block' : 'none'
    },
    attrs: {
      "height": "42px",
      "width": "42px"
    }
  }), _c('muted-icon', {
    style: {
      display: _vm.soundMuted ? 'block' : 'none'
    },
    attrs: {
      "height": "42px",
      "width": "42px"
    }
  })], 1), _c('volume-slider'), _c('button', {
    staticClass: "pure-button volume-up-button",
    attrs: {
      "aria-label": "Mute or unmute volume"
    },
    on: {
      "click": function () {
        return _vm.updateVolume(_vm.volume + 20);
      }
    }
  }, [_c('volume-up-icon', {
    attrs: {
      "height": "42px",
      "width": "42px"
    }
  })], 1)], 1)])]), _c('li', {
    class: ['toolbar-row', {
      show: _vm.isCertVisible
    }]
  }, [_c('button', {
    staticClass: "pure-button",
    attrs: {
      "aria-label": "Certificate",
      "tabindex": "8"
    },
    on: {
      "click": _vm.showCert
    }
  }, [_c('certificate-icon')], 1)])] : _vm._e()], 2) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }